<template>
  <drag-modal :visible="$store.state.dislog.filemanage" @cancel="close" title='文件管理' width='1100px' class="modal">
    <div class="file-manage">
      <!-- 面包屑 -->
      <a-breadcrumb class="breadcrumb">
        <span slot="separator" style="color: #4e4e4e">/</span>
        <a-breadcrumb-item v-for="item in breadList" :key="item.id">
          <span :class="['breadcrumb-link', currentParentId == item.id ? 'breadcrumb-now' : '']"
            @click.stop="goPath(item)">
            {{ item.name }}
          </span>
        </a-breadcrumb-item>
      </a-breadcrumb>
      <!-- 操作栏 -->
      <div class="oper">
        <div class="oper-bar">
          <a-button type="primary" @click="createFile">新建文件夹</a-button>
          <a-button type="primary" @click="$refs.uploadRef.click()">上传文件</a-button>
          <input ref="uploadRef" type="file" multiple style="display:none" @change="handleFileUpload" />
          <a-button @click="handleCopy" :disabled="!selectedIds.length">复制</a-button>
          <a-button @click="handleCut" :disabled="!selectedIds.length">剪切</a-button>
          <a-button @click="handlePaste" :disabled="!clipboardIds.length">
            粘贴
            <span v-if="clipboardIds.length" style="margin-left:4px;color:#1890ff;">
              ({{ clipboardType === 'copy' ? '复制' : '剪切' }} {{ clipboardIds.length }}项)
            </span>
          </a-button>
          <a-popconfirm title="确认批量删除勾选的文件/文件夹？" ok-text="确认" cancel-text="取消" :disabled="!selectedIds.length"
            @confirm='handleBatchDel'>
            <a-button type='danger' :disabled="!selectedIds.length">删除</a-button>
          </a-popconfirm>
        </div>
        <div>
          <a-icon v-if="!loading" @click="getLoad" type="redo"
            style="font-size: 20px;color: #1890ff;margin-top: 7px;" />
          <a-icon v-else type="loading" style="font-size: 20px;color: #1890ff;margin-top: 7px;" />
        </div>

      </div>
      <!-- 表格列表 -->
      <a-table :columns="columns" :data-source="tableData" row-key="id"
        :row-selection="{ selectedRowKeys: selectedIds, onChange: onSelectChange }" :pagination="false"
        @row-click="handleRowClick" :customRow="customRow" :scroll="{ y: 520 }">
        <template slot-scope="text, record" slot="file_name">
          <div style="display: flex;gap: 10px;">
            <span v-if="record.is_folder" class="folder-icon">📁</span>
            <span v-else class="file-icon">
              <img class="img" v-if="record.file_extension" :src="getFileIcon(record.file_key)" alt="">
              <span v-else>📄</span>
            </span>
            <span class="name-text" :style="{ color: record.is_folder ? '' : '#1890ff' }" @click="openFolder(record)">
              {{ record.file_name }}
            </span>
          </div>
        </template>
        <template slot-scope="text, record" slot="file_extension">
          <span v-if="record.is_folder" class="folder-icon">文件夹</span>
          <span v-else class="file-icon">{{ record.file_extension }}</span>
        </template>
        <template slot-scope="text, record" slot="oper">
          <div style="display: flex;gap: 15px;font-size: 14px;">
            <!-- <a-icon type="edit" @click="handleRename(record)" style="color: #1A9BFD;" title="重命名"/> -->
            <a @click="handleRename(record)">重命名</a>
            <a v-if="!record.is_folder" @click="handleDownload(record)">下载</a>
            <a v-if="!record.is_folder" @click="handleShare(record)" style="color: #8E62D4;">分享</a>
            <a-popconfirm title="确认删除此文件/文件夹吗?？" ok-text="确认" cancel-text="取消" @confirm='handleSingleDel(record)'>
              <a href="#" style="color: red;">删除</a>
              <!-- <a-icon type="delete" style="color: #FF380F;" title="删除"/> -->
            </a-popconfirm>
            <!-- <a-icon type="vertical-align-bottom"  v-if="!record.is_folder" @click="handleDownload(record)" style="color: #0FFF4D;" title="下载"/>
          <a-icon type="link" v-if="!record.is_folder" @click="handleShare(record)" style="color: #8E62D4;" title="分享链接"/> -->
          </div>
        </template>
      </a-table>
      <!--右键弹出菜单-->
      <a-dropdown v-if="contextMenu" :visible="contextMenu.visible"
        :style="{ left: contextMenu.x + 'px', top: contextMenu.y + 'px' }"
        @visibleChange="(v) => contextMenu.visible = v">
        <a-menu slot="overlay" @click="onContextMenuClick">
          <a-menu-item key="copy">复制</a-menu-item>
          <a-menu-item key="move">剪切(移动)</a-menu-item>
        </a-menu>
        <div></div>
      </a-dropdown>
      <!-- 新建文件夹弹窗 -->
      <a-modal v-model="showCreateFolder" :title="recordname" @ok="createFolder">
        <a-input v-model="folderName" :placeholder="recordname == '新建文件夹' ? '输入文件夹名称' : '输入新命名名称'"></a-input>
      </a-modal>
      <FileSee ref='FileSee' :info='info'></FileSee>
    </div>
    <Share ref="PopUpFileInformation" :FileInformation="FileInformation" @expand-first-group="handleExpandFirstGroup">
    </Share>
  </drag-modal>
</template>

<script>
import $http from "superagent"
import { Tacitly } from '@/assets/js/Tacitly'
import FileSee from "@/components/filesee"
import { getFileIcon, Filetype, getFilePath, formatFileShowName } from '../../assets/js/fileIcon'
import { onlineUrlToken } from '@/server/api'
import Share from './Share.vue'

export default {
  name: 'FileManage',
  components: { FileSee, Share },
  data() {
    return {
      currentParentId: 0,
      breadList: [{ id: 0, name: '根目录' }],
      tableData: [],
      columns: [
        { title: '名称', scopedSlots: { customRender: 'file_name' }, width: 330 },
        { title: '更新时间', dataIndex: 'updated_at' },
        { title: '类型', scopedSlots: { customRender: 'file_extension' }, width: 100 },
        { title: '大小', dataIndex: 'file_size_format', width: 100 },
        { title: '操作', scopedSlots: { customRender: 'oper' } }
      ],
      selectedIds: [],
      showCreateFolder: false,
      folderName: '',
      // 废弃：showMoveModal、targetParentId、treeData全部删除
      recordname: '',
      setfile_id: null,
      info: {},
      clipboardType: null,   // 'copy' | 'move'
      clipboardIds: [],      // 剪贴板中的文件ID
      contextMenu: {
        visible: false,
        x: 0,
        y: 0,
        record: null
      },
      loading: false,
      loadingOpenFolder: false,
      FileInformation: {},
    }
  },
  mounted() {
    this.fetchList()
    document.addEventListener('keydown', this.onKeyDown)
    document.addEventListener('click', this.hideContextMenu)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeyDown)
    document.removeEventListener('click', this.hideContextMenu)
  },
  methods: {
    getFileIcon,
    close() {
      this.$store.dispatch('openkey', { key: 'filemanage', by: false })
    },
    getLoad() {
      this.loading = true
      this.fetchList()
    },
    async fetchList() {
      const { getFileList } = await import("@/server/file")
      const res = await getFileList({ parent_id: this.currentParentId })
      if (res) {
        this.tableData = res.list
        this.breadList = res.breadcrumb
      } else {
        this.tableData = []
      }
      this.loading = false
    },
    getFilePath,
    handleRowClick() { },
    goPath(item) {
      if (this.currentParentId == item.id) return
      this.currentParentId = item.id
      this.fetchList()
    },
    Filetype,
    downFile(i) {
      const baseUrl = Tacitly.Base_Port;
      return `${baseUrl}common/download?url=${encodeURIComponent(getFilePath(i.file_key))}&filename=${encodeURIComponent(i.file_name)}`
    },
    async openFolder(record) {
      if (this.loadingOpenFolder) return
      this.loadingOpenFolder = true
      const { filedownloadApi } = await import("@/server/file")
      try {
        if (record.is_folder) {
          this.currentParentId = record.id
          this.fetchList()
        } else {
          const res = await filedownloadApi({ file_id: record.id })
          const originFileUrl = res.download_url
          if (this.Filetype(originFileUrl) == 7) {
            const url = this.downFile(record)
            fetch(url)
              .then(res => res.blob())
              .then(blob => {
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = record.file_name
                link.click()
                URL.revokeObjectURL(link.href)
              })
            return
          }

          if (Filetype(originFileUrl) == 4) {    
            onlineUrlToken(//只读文件
              {
                object: getFilePath(originFileUrl),
                type: "preview"
              }
            ).then(res => {
              this.info = {
                type: 4,
                Original_url: getFilePath(originFileUrl),
                url: res.weboffice_url,
                title: this.formatFileShowName(record.file_name),
                access_token: res.access_token,
                refresh_token: res.refresh_token,
                access_token_expired_at: res.access_token_expired_at,
                refresh_token_expired_at: res.refresh_token_expired_at,
                folderShow: true
              }
              this.$refs.FileSee.visible = true
            })
          } else {
            this.info = {
              type: Filetype(originFileUrl),
              url: originFileUrl,
              title: record.file_name,
            }
            this.$refs.FileSee.visible = true;
          }
        }
      } catch (err) {
        console.error('打开文件失败', err)
      } finally {
        this.loadingOpenFolder = false
      }
    },
    formatFileShowName,
    onSelectChange(selectedRowKeys) {
      this.selectedIds = selectedRowKeys
    },
    createFile() {
      this.showCreateFolder = true
      this.recordname = '新建文件夹'
    },
    async createFolder() {
      if (!this.folderName) return this.$message.warn('请输入文件夹名称')
      const { createFolderApi, renameApi } = await import("@/server/file")
      if (this.recordname == '新建文件夹') {
        await createFolderApi({
          parent_id: this.currentParentId,
          folder_name: this.folderName
        })
        this.$message.success('创建成功')
      } else {
        await renameApi({ file_id: this.setfile_id, new_name: this.folderName })
        this.$message.success('重命名成功')
      }
      this.showCreateFolder = false
      this.folderName = ''
      this.fetchList()
    },
    async handleFileUpload(e) {
      const files = e.target.files
      const formData = new FormData();
      formData.append('file', files[0]);
      formData.append('parent_id', this.currentParentId);
      $http.post(Tacitly.Base_Port + "netdisk/upload", formData)
        .set('Authorization', localStorage.getItem("t"))
        .then((res) => {
          if (res.body.code == '0000') {
            this.$message.success('上传完成')
            this.fetchList()
          } else {
            this.$message.error(res.body.msg)
          }
        })
      e.target.value = ''
    },
    async handleRename(record) {
      this.recordname = '重命名文件夹'
      this.showCreateFolder = true
      this.setfile_id = record.id
      this.folderName = record.file_name
    },
    async handleDownload(record) {
      const { filedownloadApi } = await import("@/server/file")
      const res = await filedownloadApi({ file_id: record.id })
      const originFileUrl = res.download_url
      const a = document.createElement('a')
      a.href = originFileUrl
      a.target = '_blank'
      a.download = record.file_name
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    handleShare(cet) {
      this.FileInformation = cet
      this.$store.dispatch("openkey", { key: 'PopUpFileInformation', by: true })
      // this.$store.dispatch("openkey", { key: 'filemanage', by: false })
    },
    handleCopy() {
      if (!this.selectedIds.length) return
      this.clipboardIds = [...this.selectedIds]
      this.clipboardType = 'copy'
      this.$message.info(`已复制 ${this.clipboardIds.length} 项，前往目标目录点击粘贴`)
    },
    handleCut() {
      if (!this.selectedIds.length) return
      this.clipboardIds = [...this.selectedIds]
      this.clipboardType = 'move'
      this.$message.info(`已剪切 ${this.clipboardIds.length} 项，前往目标目录点击粘贴`)
    },
    onContextMenuClick({ key }) {
      this.clipboardIds = [...this.selectedIds]
      if (key === 'copy') {
        this.clipboardType = 'copy'
        this.$message.info(`已复制 ${this.clipboardIds.length} 项，前往目标目录点击粘贴`)
      } else if (key === 'move') {
        this.clipboardType = 'move'
        this.$message.info(`已剪切 ${this.clipboardIds.length} 项，前往目标目录点击粘贴`)
      }
      this.contextMenu.visible = false
    },
    customRow(record, index) {
      return {
        onContextmenu: (event) => {
          event.preventDefault()
          if (!this.selectedIds.includes(record.id)) {
            this.selectedIds = [record.id]
          }
          this.contextMenu.visible = true
          this.contextMenu.x = event.clientX
          this.contextMenu.y = event.clientY
          this.contextMenu.record = record
        }
      }
    },
    hideContextMenu() {
      this.contextMenu.visible = false
    },
    onKeyDown(e) {
      const ctrlKey = e.ctrlKey || e.metaKey
      if (ctrlKey && e.key.toUpperCase() === 'C') {
        if (this.selectedIds.length === 0) return
        e.preventDefault()
        this.clipboardIds = [...this.selectedIds]
        this.clipboardType = 'copy'
        this.$message.info(`Ctrl+C 已复制 ${this.clipboardIds.length} 项`)
      }
      if (ctrlKey && e.key.toUpperCase() === 'X') {
        if (this.selectedIds.length === 0) return
        e.preventDefault()
        this.clipboardIds = [...this.selectedIds]
        this.clipboardType = 'move'
        this.$message.info(`Ctrl+X 已剪切 ${this.clipboardIds.length} 项`)
      }
      if (ctrlKey && e.key.toUpperCase() === 'V') {
        if (!this.clipboardIds.length) return
        e.preventDefault()
        this.handlePaste()
      }
    },
    async handlePaste() {
      if (!this.clipboardIds.length || !this.clipboardType) {
        this.$message.info('剪贴板为空，先复制或剪切文件')
        return
      }
      // 防护：不能把父文件夹粘贴进自身
      if (this.clipboardIds.includes(this.currentParentId)) {
        this.$message.warn('不能将文件夹粘贴到自身内部')
        return
      }
      try {
        if (this.clipboardType === 'copy') {
          const { fileCopyApi } = await import("@/server/file")
          await fileCopyApi({
            file_id: this.clipboardIds.join(','),
            target_parent_id: this.currentParentId
          })
          this.$message.success('复制成功')
        } else if (this.clipboardType === 'move') {
          const { fileMoveApi } = await import("@/server/file")
          await fileMoveApi({
            file_id: this.clipboardIds.join(','),
            target_parent_id: this.currentParentId
          })
          this.$message.success('移动成功')
        }
        this.selectedIds = []
        // 粘贴完成，刷新列表
        this.fetchList()
        // 清空剪贴板
        this.clipboardType = null
        this.clipboardIds = []
      } catch (e) {
        console.error(e)
        this.$message.error('粘贴失败')
      }
    },

    // ==================== 删除 ====================
    async handleSingleDel(record) {
      const { fileDeleteApi } = await import("@/server/file")
      await fileDeleteApi({ file_id: record.id })
      this.fetchList()
      this.$message.success('删除成功')
    },
    async handleBatchDel() {
      const { fileDeleteApi } = await import("@/server/file")
      await fileDeleteApi({ file_id: this.selectedIds.join(',') })
      this.selectedIds = []
      this.fetchList()
      this.$message.success('删除成功')
    },
    handleExpandFirstGroup() {
      this.$emit('handle-expand-first-group')
    }

  }
}
</script>


<style lang="less" scoped>
:deep(.ant-table-body) {

  /* 滚动条整体宽度 */
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  /* 轨道背景，透明 */
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  /* 滑块：浅灰+圆角 */
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }

  /* hover滑块加深 */
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.35);
  }
}

.breadcrumb {
  margin-bottom: 16px;
}

.breadcrumb-link {
  cursor: pointer;
  color: #4e4e4e;
}

.breadcrumb-now {
  color: #2ba4f5;
}

.oper {
  display: flex;
  justify-content: space-between;
  align-content: center;
  margin-bottom: 16px;
}

.oper-bar {
  display: flex;
  gap: 16px;
}

.folder-icon,
.file-icon {
  margin-right: 6px;
}

.img {
  width: 16px;
  height: 16px;
}

.name-text {

  max-width: 240px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

:deep(.ant-modal-body) {
  padding: 10px !important;
}
</style>